import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BooleanRule } from '../../../models/feature-flag.model';

/**
 * Component for building and managing boolean rules (simple on/off toggle)
 */
@Component({
  selector: 'cbre-boolean-rule',
  templateUrl: './boolean-rule.component.html',
  styleUrls: ['./boolean-rule.component.scss'],
  standalone: false,
})
export class BooleanRuleComponent implements OnInit {
  /**
   * Parent form group
   */
  @Input() parentForm: FormGroup;

  /**
   * Event emitted when the rule changes
   */
  @Output() ruleChanged = new EventEmitter<BooleanRule>();

  constructor() {}

  ngOnInit(): void {
    // Make sure we have the correct structure
    this.ensureFormStructure();
  }

  /**
   * Ensure the form has the correct structure for boolean rules
   */
  private ensureFormStructure(): void {
    const ruleGroup = this.parentForm.get('rule') as FormGroup;
    if (!ruleGroup.get('value')) {
      ruleGroup.patchValue({
        type: 'boolean',
        value: false,
      });
    }
  }

  /**
   * Toggle the boolean value
   */
  toggleValue(value: boolean): void {
    const ruleGroup = this.parentForm.get('rule') as FormGroup;
    ruleGroup.patchValue({
      value: value,
    });

    // Emit the updated rule
    this.ruleChanged.emit(ruleGroup.value as BooleanRule);
  }
}
